// Import enumerations.
import {
	EndorsementEligibilityStatusType,
} from '@app/enumerations';

export default class EndorsementEligibilityStatus {

	public endorsementId: number | null = null;
	public status: EndorsementEligibilityStatusType | null = null

	public constructor() {

	}
}